<template>
 <div>
   <b-button variant="success" size="sm" @click="saveDetails()" :disabled="!this.transition && !this.priority ? true : false">
     <font-awesome-icon :icon="['fas', 'save']"/>
     Desar detalls
    </b-button>
  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  props: {
    ticket: {
      required: true,
      type: Object
    },
    priority: {
      required: true,
      Type: Number
    },
    transition: {
      required: true,
      Type: String
    },
    newTicketAssigned: {
      required: false,
      Type: String
    }
  },
  methods: {
    saveDetails () {
      var data = {
        ticket_id: this.ticket.id,
        codi_xarxa: this.$store.getters.getUser.id,
        id_prioritat: this.priority
      }
      if (this.priority && !this.transition) {
        this.$store.dispatch('changePriorityTicket', data)
      } else {
        var valid = true
        data['transition'] = this.transition
        // Al cas de tickets duplicats cal l'id del nou ticket a assignar
        if (this.transition === 'markDuplicated') {
          if (this.isNullOrUndefined(this.newTicketAssigned)) {
            valid = false
            this.notifyError('Falta informació', 'Has d\'escollir un nou ticket a assignar')
          } else {
            data['ticket'] = this.newTicketAssigned
          }
        }
        if (valid) {
          this.$store.dispatch('managerTransitionTicket', data)
          this.transition = null
        }
      }
    }
  }
}
</script>

<style scoped>
</style>
